/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerverwaltungEinstellungenDto } from '../../models/lexplus-benutzerverwaltung-einstellungen-dto';

export interface BenutzerverwaltungEinstellungenControllerFindV1$Params {
}

export function benutzerverwaltungEinstellungenControllerFindV1(http: HttpClient, rootUrl: string, params?: BenutzerverwaltungEinstellungenControllerFindV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerverwaltungEinstellungenDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungEinstellungenControllerFindV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerverwaltungEinstellungenDto>;
    })
  );
}

benutzerverwaltungEinstellungenControllerFindV1.PATH = '/v1/benutzerverwaltung/einstellungen';
